export function userInitial(name) {
  if (!name || !String(name).trim()) return '?';
  return String(name).trim().slice(0, 1).toUpperCase();
}

export function parseProfileData(raw) {
  if (!raw) return { bio: '' };
  try {
    const parsed = JSON.parse(raw);
    return { bio: typeof parsed.bio === 'string' ? parsed.bio : '' };
  } catch (_) {
    return { bio: '' };
  }
}

export function buildProfileData(bio, existingRaw) {
  let base = {};
  if (existingRaw) {
    try {
      base = JSON.parse(existingRaw);
      if (typeof base !== 'object' || base === null || Array.isArray(base)) {
        base = {};
      }
    } catch (_) {
      base = {};
    }
  }
  return JSON.stringify({ ...base, bio: bio.trim() });
}

export function formatDateTime(value, lang) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  const locale = lang === 'zh' ? 'zh-CN' : 'en-US';
  return date.toLocaleString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatMemberSince(value, lang) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const locale = lang === 'zh' ? 'zh-CN' : 'en-US';
  const formatted = date.toLocaleDateString(locale, { year: 'numeric', month: 'long' });
  return lang === 'zh' ? `${formatted}注册` : `Joined ${formatted}`;
}

export function truncateUuid(uuid) {
  if (!uuid || uuid.length < 12) return uuid || '—';
  return `${uuid.slice(0, 4)}…${uuid.slice(-4)}`;
}

export function computeCompleteness({ name, bio, emailVerified }) {
  const items = [
    String(name || '').trim().length >= 3,
    String(bio || '').trim().length > 0,
    Boolean(emailVerified),
  ];
  const score = items.filter(Boolean).length;
  return { score, total: items.length, items };
}

export function isProfileDirty({ name, bio }, snapshot) {
  if (!snapshot) return false;
  return (
    String(name || '').trim() !== String(snapshot.name || '').trim()
    || String(bio || '').trim() !== String(snapshot.bio || '').trim()
  );
}
